module.exports = __webpack_public_path__ + "assets/img/thumb-Logitech-MX-Anywhere-3-Video.55c24e51.webp";